<template>
  <modal 
    name="register-modal" 
    :pivotY="0.2"
    :height="'auto'"
    :width="500"
    @before-open="beforeOpen"
    @opened="opened">
    
    <div class="modal-header">
      <div class="modal-title">
        {{ title }}
      </div>

      <a href="#"
        v-on:click.prevent="$modal.hide('register-modal')"
        class="text-gray-500 hover:text-gray-600">
        <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/img/feather-sprite.svg#x-circle"/>
        </svg>
      </a>
    </div>

    <div class="modal-body">

      <template v-if="registered">
        <label class="text-base">
          Great. Your account has been created successfully. 
          <!-- We sent you a welcome email. -->
        </label>

        <div class="button-line">
          <SubmitButton :onClick="close" :loading="loading" label="Got it." :isFullWidth="true" />
        </div>
      </template>

      <template v-else>

        <label class="text-base text-gray-900">
          Create your account to easily access all your applications easily and
          also to communicate with your brokers.
        </label>

        <div class="label-line">
          <label class="text-sm">Email</label>
        </div>
        
        <div class="form-line">
          <input type="text" v-model="email" ref='email' class="input-standard" :disabled="loading" />
          <div v-if="emailError !== null" class="input-error">{{ emailError }}</div>
        </div>

        <div class="label-line">
          <label class="text-sm">Password</label>
        </div>

        <div class="form-line">
          <input type="password" v-model="password" ref="password" class="input-standard" :disabled="loading" />
          <div v-if="passwordError !== null" class="input-error">{{ passwordError }}</div>
        </div>

        <div class="label-line">
          <label class="text-sm">Please type your password again</label>
        </div>

        <div class="form-line">
          <input type="password" v-model="passwordAgain" ref="passwordAgain" class="input-standard" :disabled="loading" />
          <div v-if="passwordAgainError !== null" class="input-error">{{ passwordAgainError }}</div>
        </div>

        <div class="button-line">
          <SubmitButton :onClick="submit" :loading="loading" label="Sign up!" :isFullWidth="true" />
        </div>
      </template>
    </div>
  </modal>
</template>

<script>
  import validator    from 'validator'
  import SubmitButton from '@/shared/components/form/SubmitButton'

  export default {

    components : {
      SubmitButton
    },

    data() {
      return {
        title              : null,
        loading            : false,
        registered         : false,
        
        email              : process.env.NODE_ENV == 'development' ? 'ericbae@gmail.com' : '',
        emailError         : null,
        
        password           : process.env.NODE_ENV == 'development' ? 'password' : '',
        passwordError      : null,
        
        passwordAgain      : null,
        passwordAgainError : null,
        
        newsletterFrequency: 'weekly'
      }
    },

    methods : {

      beforeOpen(event) {
        this.title               = "Create your account for " + this.getAppName
        this.loading             = false
        this.registered          = false
        this.email               = this.$store.state[this.$store.state.view + 'Module'].client.applicants[0].person.email,
        this.emailError          = null
        this.password            = process.env.NODE_ENV == 'development' ? 'password' : null,
        this.passwordError       = null
        this.passwordAgain       = process.env.NODE_ENV == 'development' ? 'password' : null,
        this.passwordAgainError  = null
      },

      opened() {
        if(this.$refs.email != null) {
          this.$refs.email.focus()
        }
      },

      close() {
        this.$modal.hide('register-modal')
      },

      submit() {
        let valid               = true
        this.emailError         = null
        this.passwordError      = null
        this.passwordAgainError = null

        if(this.email == null || !validator.isEmail(this.email)) {
          this.emailError = "Please type a valid email."
          valid = false;
        }

        if(this.password == null || this.password.length == 0) {
          this.passwordError = "Please type a valid password."
          valid = false;
        }

        if(this.password != null && this.password != this.passwordAgain) {
          this.passwordAgainError = "This does not match the password above."
          valid = false;
        }

        if(valid) {
          this.loading = true

          this.apiPost({
            clientId: this.$route.params.clientId,
            email   : this.email.toLowerCase().trim(),
            password: this.password,
          }, 'auth/register-client', (data) => {
            this.loading = false

            if(data.error != null) {
              this.emailError = data.error
            } else {
              this.title      = "Registration successful"
              this.registered = true
            }
          })
        }
      },
    },
  }
</script>